import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import FeaturesSection from "@/components/FeaturesSection";
import AboutSection from "@/components/AboutSection";
import DataSection from "@/components/DataSection";
import WhitepaperSection from "@/components/WhitepaperSection";
import PartnersSection from "@/components/PartnersSection";
import ContactSection from "@/components/ContactSection";
import NewsletterSection from "@/components/NewsletterSection";
import Footer from "@/components/Footer";
import NewsTicker from "@/components/dashboard/NewsTicker";

export default function LandingPage() {
  return (
    <div data-testid="landing-page">
      <Navbar />
      <NewsTicker />
      <HeroSection />
      <FeaturesSection />
      <DataSection />
      <AboutSection />
      <WhitepaperSection />
      <PartnersSection />
      <ContactSection />
      <NewsletterSection />
      <Footer />
    </div>
  );
}
